import { ICsvData } from '@/interfaces/storageTracking/ICsvData.ts';
import { IDropdownItem } from '@/interfaces/storageTracking/IDropdownItem.ts';
import { TrialLimits } from '@/interfaces/storageTracking/TrialLimits.ts';
import { IDefinitionsHolder } from '@/interfaces/storageTracking/IDefinitionsHolder.ts';
import { IFilters } from '@/interfaces/storageTracking/IFilters.ts';
import { IRedactedProjectDataWithSources } from '@/interfaces/storageTracking/IRedactedProjectData.ts';
import { ICompanyReturn } from '@/interfaces/storageTracking/ICompanyReturn.ts';
import { ICompanySearchResponse } from '@/interfaces/storageTracking/ICompanySearchResponse.ts';
import { IProjectSearchResponse } from '@/interfaces/storageTracking/IProjectSearchResponse.ts';
import { useApi } from '../useApi.ts';

const apiCall = useApi('storageTracking');

async function getAllDataFilteredRedacted (filters: IFilters): Promise<IProjectSearchResponse> {
    return (await apiCall.post <IFilters, IProjectSearchResponse>({ endpoint: '/snowflake/AllDataFilteredRedacted', payload: filters })).data;
}

async function getAllDataFilteredUnredacted (filters: IFilters): Promise<Array<ICsvData>> {
    return (await apiCall.post <IFilters, Array<ICsvData>>({ endpoint: '/snowflake/AllDataFilteredUnredacted', payload: filters })).data;
}

async function getAllDataFilteredWithSourceDates (filters: IFilters): Promise<Array<IRedactedProjectDataWithSources>> {
    return (await apiCall.post <IFilters, Array<IRedactedProjectDataWithSources>>({ endpoint: '/snowflake/AllDataFilteredWithSourceDates', payload: filters })).data;
}

async function getFilteredCompanies (filters: IFilters): Promise<ICompanySearchResponse> {
    return (await apiCall.post <IFilters, ICompanySearchResponse>({ endpoint: '/snowflake/getFilteredCompanies', payload: filters })).data;
}

async function getProjectById (id: number): Promise<ICsvData> {
    return (await apiCall.get <ICsvData>({ endpoint: `/snowflake/ProjectById/${id}` })).data;
}

async function getCompanyData (companyName: string, filters: IFilters): Promise<ICompanyReturn> {
    return (await apiCall.post<IFilters, ICompanyReturn>({ endpoint: `/snowflake/CompanyData/${companyName}`, payload: filters })).data;
}

async function getFilteredUserCountries (): Promise<Array<IDropdownItem>> {
    return (await apiCall.get <Array<IDropdownItem>>({ endpoint: '/snowflake/FilteredCountries' })).data;
}

async function getTrialUserLimits (): Promise<TrialLimits> {
    return (await apiCall.get <TrialLimits>({ endpoint: '/snowflake/TrialUserAccess' })).data;
}

async function getDefinitions (): Promise<IDefinitionsHolder> {
    return (await apiCall.get <IDefinitionsHolder>({ endpoint: '/public/AllDefinitions' })).data;
}

async function refreshCachedUser (): Promise<void> {
    const endpoint = '/admin/RefreshCachedUser';
    await apiCall.get<void>({ endpoint });
}

export const DataApi = {
    getAllDataFilteredRedacted,
    getAllDataFilteredUnredacted,
    getAllDataFilteredWithSourceDates,
    getCompanyData,
    getProjectById,
    getFilteredCompanies,
    getFilteredUserCountries,
    getTrialUserLimits,
    getDefinitions,
    refreshCachedUser,
};
